import Backend from 'backend';
import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {FeatureCustomizationProvider} from "../../util/feature-customization-provider";
import {ValidationController, ValidationRules} from "aurelia-validation";

@inject(Backend, Router, FeatureCustomizationProvider, ValidationController)
export class CustomerUserCreateScreen {
    backend;
    router;
    featureCustomizationProvider;

    // To be posted
    customerUser;

    validationController;

    constructor(backendFacade, router, featureCustomizationProvider, validationController) {
        this.backend = backendFacade;
        this.router = router;
        this.featureCustomizationProvider = featureCustomizationProvider;
        this.validationController = validationController;
    }

    activate(params) {
      this.customerId = params.customerId;
    }

    bind() {
      // ValidationRules
            // .ensure('name')
            //   .required()
            // .ensure('discountRate')
            //   .displayName('Rabatt')
            //   .satisfies(value => !value || numeral.validate(value, 'en'))
            //   .withMessage('Rabatt må være et tall')
            // .on(this.customerUser);
    }

    createSubmit() {
      return this.validationController.validate()
        .then(result => {
          if (!result.valid) {
            return;
          }

          return this.backend.CustomerUserCrud_create(this.customerId, this.customerUser)
            .then(() => this.router.navigateToRoute("customer-details", { customerId: this.customerId}));
        });
    }
}
